import React from "react";
import { createRoot } from "react-dom/client";

import Library from './react-components/pages/Library';

const listOfContainers = {
  "#library-react-container": <Library />,
};

Object.keys(listOfContainers).forEach((containerName) => {
  const containerElements = document.querySelectorAll(containerName);

  if (containerElements.length > 0) {
    containerElements.forEach((containerElm) => {
      const dataAttributes = containerElm
        .getAttributeNames()
        .filter((attributeName) => attributeName.startsWith("data-"))
        .reduce((result, attributeName) => {
          const key = attributeName.slice(5); // Remove "data-" prefix
          const value = containerElm.getAttribute(attributeName);
          result[key] = value;
          return result;
        }, {});

      const component = listOfContainers[containerName];

      if (component) {
        // add data attributes as props to the component
        const props = { data: dataAttributes };
        listOfContainers[containerName] = React.cloneElement(component, props);
        // console.log(containerName, props);
      } else {
        console.warn(`Component not found for container "${containerName}"`);
      }

      // create a new root and render the component
      const rootElm = document.createElement("div");
      containerElm.appendChild(rootElm);
      const root = createRoot(rootElm);
      root.render(listOfContainers[containerName]);
    });
  }
});
